export const BUDGET_COLORS = [
  {
    name: 'Red',
    value: '#FE8079'
  },
  {
    name: 'Orange',
    value: '#F18D00'
  },
  {
    name: 'Yellow',
    value: '#E8CB57'
  },
  {
    name: 'Green',
    value: '#34C759'
  },
  {
    name: 'Aqua',
    value: '#00C7BE'
  },
  {
    name: 'Blue',
    value: '#007AFF'
  },
  {
    name: 'Purple',
    value: '#A396F2'
  },
  {
    name: 'Brown',
    value: '#A2845E'
  }
];
